export const COMPACT_PLAY_TYPE_VALUES = {
  IN_FRAME: 1,
  EXPANDED_VIEW: 2,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/compact-play-type.js